module.exports = __webpack_public_path__ + "img/cpzx.8ffadee5.png";